export default "__VITE_ASSET__DTGEXxIs__";